module.exports = __webpack_public_path__ + "media/assets/lineDrawing-8e36ba900176c484e04529cdc2a9df4a.svg";